import { useContext } from 'react';
import AppContext from '@context';
import { getProposalByID } from '@services/proposals';
import { ProposalItemStateInterface } from '@context/reducers';
import useAmplitude from './useAmplitude';

const useUpdateProposal = ({ proposalId }: { proposalId: string }) => {
  const {
    state: { proposals },
    dispatch,
  } = useContext(AppContext);
  const { amplitudeEvent } = useAmplitude();

  function searchedProposal(
    proposalLoadedId: string,
  ): ProposalItemStateInterface | false {
    const proposalSearched = proposals?.pending.data.find(
      (proposalState) => proposalState.id === proposalLoadedId,
    );
    return proposalSearched || false;
  }

  function isloadingProposal(): boolean {
    const loadingSearched = searchedProposal(proposalId);
    if (!loadingSearched) {
      return false;
    }
    return loadingSearched.lastLocationState?.fetch.isFetching || false;
  }

  function isErrorProposal(): boolean {
    const errorSearched = searchedProposal(proposalId);
    if (!errorSearched) {
      return false;
    }
    return errorSearched.lastLocationState?.error || false;
  }

  const fetchProposal = async () => {
    if (proposalId) {
      dispatch({
        type: 'proposal_last_location_loading',
        payload: { proposalId, isFetching: true },
      });

      return getProposalByID(proposalId)
        .then((response) => {
          dispatch({
            type: 'proposal_last_location_loaded',
            payload: { proposalId: response.id, proposal: response },
          });
          amplitudeEvent('drawer_proposal_pending_viewed', {
            source: 'visualizar-drawer-sucesso',
            proposal_id: proposalId,
          });
        })
        .catch(() => {
          dispatch({
            type: 'proposal_last_location_error',
            payload: { proposalId, error: true },
          });
          dispatch({
            type: 'ui_drawerProposal_set_show',
            payload: { isShow: false, proposalId: '' },
          });
          dispatch({ type: 'proposal_selection_clear' });
          amplitudeEvent('drawer_proposal_pending_viewed', {
            source: 'visualizar-drawer-error',
            proposal_id: proposalId,
          });

          window.dispatchEvent(
            new CustomEvent('notificationShow', {
              detail: {
                heading: 'Não foi possível realizar esta ação',
                message: 'Tente novamente mais tarde.',
                severity: 'error',
              },
            }),
          );
        });
    }

    return Promise.reject(new Error('ProposalId not found'));
  };

  return { fetchProposal, isErrorProposal, isloadingProposal };
};

export default useUpdateProposal;
